<template>
    <v-list-item>
        <v-list-item-content class="text-left">
            <v-list-item-title>{{ item }}</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
            <v-btn icon>
                <v-icon v-text="icons.mdiCheckCircle" color="green"
                        v-if="green"></v-icon>
                <v-icon v-text="icons.mdiCloseCircle" color="red" v-else></v-icon>
            </v-btn>
        </v-list-item-action>
    </v-list-item>
</template>
<script>

import Snackbar from "@/components/Snackbar.vue";
import {useVuetify} from "@/composables/vuetify";
import {computed, toRef, ref, toRefs} from "vue";
import MixinIcon from "@/mixins/MixinIcon";
import {usePhonesStore} from "@/stores/PhonesStore";
import {storeToRefs} from "pinia";
import {useInformationStore} from "@/stores/InformationStore";

export default {
    name: 'InformationSystemListRow',
    components: {
        Snackbar
    },
    props: {
        item: {
            type: String,
            required: true,
        },
        green: {
            type: Boolean,
            required: true,
        },
    },
    setup(props, context) {

        const vuetify = useVuetify();
        let isDark = computed(() => {
            return vuetify.theme.dark
        })
        const icons = MixinIcon.data().icons

        // props of item, and green
        const {item, green} = toRefs(props)

        // FIXME: REMOVE THIS
        console.log('props', props, 'item', item, 'green', green)

        return {
            icons,
            isDark,
            item,
            green
        }

    }

}

</script>
<style>
.min-w-200 {
    min-width: 200px;
}

.min-w-80 {
    min-width: 80px;
}
</style>
